import { IconCirclePlus } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import { postApi } from '../../api/call.api'
import { urlApi } from '../../api/url.api'
import IconButton from '../../components/Buttons/IconButton'
import DateRange from '../../components/DateRange/DateRange'
import DropDown from '../../components/DropDown/DropDown'
import Pagination from '../../components/Pagination/Pagination'
import DateFilterInfoPopup from '../../components/Popover/DateFilterInfoPopup'
import SearchComponent from '../../components/Search/SearchComponent'
import Layout from '../../layout/Layout'
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller'
import { dateIntoYYYY_MM_DD } from '../../utils/dateTimeConverter'
import CreatePromotionModal from './Components/CreatePromotionModal'
import PromotionLinkCard from './Components/PromotionLinkCard'
import { accessCheck } from '../../utils/accessCheck'
import { accessKeys } from '../../statics/accessKeys'

const Promotions = () => {

    const sortingFilterList = [
        {
            id: null,
            name: "All"
        }, {
            id: 1,
            name: "Clicks H-L",
            value: 'linkClicks,DESC'
        }, {
            id: 2,
            name: "Clicks L-H",
            value: 'linkClicks,ASC'
        }
    ]
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(4);
    const [searchData, setSearchData] = useState('');
    const [date, setDate] = useState({ startDate: '', endDate: '' });
    const [sortFilter, setSortFilter] = useState(null);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });
    function handlePageChange(page) {
        setActivePage(page);
    }

    async function getList() {
        loadingShow();
        let sortingFilterLocal = sortingFilterList?.find(item => item?.name == sortFilter)
        let postData = {
            "startDate": dateIntoYYYY_MM_DD(date.startDate),
            "endDate": dateIntoYYYY_MM_DD(date.endDate)
        }
        let url = `${urlApi.promotionList}?page=${activePage}&limit=${perPage}&`;
        if (searchData) {
            url += "search=" + searchData + "&"
        }
        if (sortingFilterLocal?.id) {
            url += `sort=${sortingFilterLocal ? sortingFilterLocal?.value : null}&`
        }
        let resp = await postApi((date?.startDate ? postData : {}), url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data.items,
                totalCount: resp.data.count
            });
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    function onDateChange(p) {
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        setActivePage(1);
        setDate(newDate)
    }

    function onSortingFilterChange(sort) {
        setActivePage(1)
        setSortFilter(sort)
    }

    useEffect(() => {
        if (accessCheck(accessKeys.createAndUpdatePromotion)) {
            getList();
        }
        return () => {
        };
    }, [activePage, searchData, date, sortFilter]);

    function reset() {
        setActivePage(1);
        setSearchData('');
        setDate({ startDate: '', endDate: '' });
        setSortFilter(null);
    }

    return (
        <Layout>
            <div className='flex mb-3 gap-3 flex-wrap justify-between items-center'>
                <p className='text-[17px] font-bold mb-0 text-[var(--grey)] px-2'>Promotions</p>
                <CreatePromotionModal buttonComponent={<IconButton icon={<IconCirclePlus size={20} />} text={"Create Promotion"} />} callback={() => getList()} />
            </div>

            <div className="flex mb-3 items-center gap-3 flex-wrap">
                <SearchComponent onClear={() => { document.getElementById("link-table-search").value = ""; setSearchData('') }} inputValue={searchData}
                    onSearch={() => { setSearchData(document.getElementById("link-table-search")?.value); setActivePage(1) }} inputId='link-table-search' placeholder={"Search Promotions..."} />
                <DateRange onApplyClick={(date) => onDateChange(date)} date={date} cssClass={'ms-auto'} />
                {date?.startDate && <DateFilterInfoPopup />}
                <DropDown title={"Sort By"} list={sortingFilterList?.map(item => item?.name)} defaultValue={sortFilter} onSelect={(name) => onSortingFilterChange(name)} />
            </div>

            {tableData?.data?.length > 0 ?
                tableData?.data?.map((item, index) => (
                    <PromotionLinkCard key={index} cardData={item} resetFunction={() => reset()} isMain />
                ))
                : <p className='text-center my-16 text-sm text-red-500'>No Data Available</p>
            }

            <Pagination itemsPerPage={perPage} totalCount={tableData.totalCount} pageChangeFunction={(pageNum) => handlePageChange(pageNum)} currentPage={activePage} />

        </Layout>
    )
}

export default Promotions